import { CircularProgress } from '@mui/material';
import Joi from 'joi';
import { useEffect, useState } from 'react';
import { IoArrowBackSharp } from 'react-icons/io5';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { Button, Col, Label, Row } from 'reactstrap';
import ErrorMessageComponent from '../../components/ErrorMessageComponent';
import InputComponent from '../../components/InputComponent';
import { useAuth } from '../../context/AuthContext';
import { useAvailableModulesContext } from '../../context/AvailableModulesContext';
import Toast from '../../helpers/Toast';
import { UserService } from '../../services/UserService';
import Banner from './Banner';

export default function ForgotPassword() {
    const userService = new UserService();
    const { reactAppName } = useAvailableModulesContext();
    const navigate = useNavigate();
    const { isUserLoggedIn } = useAuth();
    const [email, setEmail] = useState("");
    const [validationResult, setValidationResult] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);


    const intl = useIntl();
    const schema = Joi.object({
        email: Joi.string().email({ tlds: { allow: false } }).required().messages({
            'string.email': intl.formatMessage({ id: "Screens.Auth.Validation.EmailFormat" }),
            'any.required': intl.formatMessage({ id: "Screens.Auth.Validation.EmailRequired" }),
            'string.base': intl.formatMessage({ id: "Screens.Auth.Validation.EmailRequired" }),
            'string.empty': intl.formatMessage({ id: "Screens.Auth.Validation.EmailRequired" }),
        }),
    });

    const clickRecoverPassword = async () => {

        setLoading(true);

        try {

            //Validamos o formulário
            var result: any = await validateForm(email);

            if (result.error != null) {
                setValidationResult(result.error.details);
                setLoading(false);
                return;
            }

            setValidationResult([]);

            //Tentar ligar API para enviar email
            var response = await userService.ForgotPassword(email);

            if (response.success !== true) {
                Toast.Show("error", response.message);
                setLoading(false);
                return;
            }

            setLoading(false);
            Toast.Show("success", response.message);

            //Redirecionamos o user
            navigate("/login");
        } catch (exp) {
            setLoading(false);
            Toast.Show("error", "Ocorreu um erro ao recuperar password. Por favor tente novamente dentro de segundos.");
        }
    }

    const validateForm = (email: string) => {
        return new Promise(function (resolve) {
            var validationResult = schema.validate(
                {
                    email,
                }, { abortEarly: false });
            resolve(validationResult);
        });
    }

    useEffect(() => {
        if (isUserLoggedIn) {
            navigate('/');
        }
    }, [isUserLoggedIn]);

    return (
        <Row style={{ display: "flex", height: "100%", margin: "0px", padding: "0px" }}>

            {/* Image on left */}
            <Banner />

            {/* Right*/}
            <Col md={6} style={{ display: "flex", alignItems: "center", alignContent: "center", justifyContent: "center", flexDirection: "column" }}>

                <Row style={{ marginBottom: "20px", width: "50%" }}>
                    <Col md={12} className="siteNameContainer">
                        <span className="siteNameBackLogo"><IoArrowBackSharp className="pageTitleBackIcon" onClick={() => { navigate('/login'); }} /></span>
                        <Label className='siteName'>{reactAppName}</Label>
                        <span style={{ flex: 1 }}></span>
                    </Col>
                </Row>

                <Row style={{ marginBottom: "20px" }}>
                    <Col md={12} className="siteWelcome">
                        <Label><FormattedMessage id="Screens.Auth.SubTitle.ForgotPassword" /></Label>
                    </Col>
                </Row>

                {/* Input email*/}
                <Row style={{ margin: "0px 0px 20px 0px", padding: "0px", minWidth: "50%" }}>
                    <InputComponent
                        xl={12}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ textAlign: "center", width: "100%" }}
                        type={"text"}
                        value={email}
                        label={intl.formatMessage({ id: "Screens.Auth.Input.Email" })}
                        readOnly={false}
                        onChange={(text: string) => setEmail(text)}
                    />
                </Row>
                <ErrorMessageComponent validationResult={validationResult} fieldToValidate="email" />

                <Row style={{ margin: "20px 0px 50px 0px", padding: "0px", minWidth: "50%" }}>
                    <Col md={12} sm={12} xs={12} lg={12} style={{ textAlign: "center" }}>
                        <Row className="loginbuttons" style={{ margin: "0px", padding: "0px", minWidth: "50%" }}>
                            <Col md={12} sm={12} xs={12} lg={12} style={{ textAlign: "center", display: "flex", justifyContent: "center" }}>
                                <Button className="forgotPassword" onClick={clickRecoverPassword} disabled={loading}>
                                    {loading === true && (
                                        <CircularProgress style={{ marginRight: "10px" }} size={"25px"} />
                                    )}
                                    <FormattedMessage id="Screens.Auth.Button.ForgotPassword" />
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}